import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ResultItem from "./resultItem";

const styles = theme => ({
  root: {
    paddingBottom: theme.spacing.unit * 2,
    overflowX: "scroll",
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing.unit
    }
  }
});

function ResultList(props) {
  const { classes } = props;

  return (
    <Paper className={classes.root} square={true}>
      <List>
        { props.posts.map((post) =>
          <ResultItem post={post} key={post.id} /> )}
      </List>
    </Paper>
  );
}

ResultList.propTypes = {
  classes: PropTypes.object.isRequired,
  posts: PropTypes.array.isRequired
};
export default withStyles(styles)(ResultList);
